import Card from "@mui/material/Card"
import CardHeader from "@mui/material/CardHeader"
import CardContent from "@mui/material/CardContent"
import CardActions from "@mui/material/CardActions"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Button, Chip, Menu, MenuItem, Stack, Tooltip } from "@mui/material"
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded"
import TocRoundedIcon from "@mui/icons-material/TocRounded"
import { useState } from "react"
import { Link } from "react-router-dom"
import AddClassSchedule from "../modals/AddClassSchedule"
import AcademicYearSelect from "../common/AcademicYearSelect"

export default function CourseCard({
  data,
  showBatches,
  edit,
  deleteCourse,
  addBatch,
  batches,
  selectedBatch,
  setSelectedBatch,
}) {
  const [academicYear, setAcademicYear] = useState(2023)
  const [menu, setMenu] = useState(null)
  const openMenu = (event) => setMenu(event.currentTarget)
  const closeMenu = () => setMenu(null)
  return (
    <Card>
      <CardHeader
        action={
          <IconButton onClick={openMenu}>
            <MoreVertIcon />
          </IconButton>
        }
        title={data?.name}
      />
      <CardContent>
        {showBatches && (
          <>
            <AcademicYearSelect
              value={academicYear}
              setValue={setAcademicYear}
            />
            {batches && batches.length > 0 ? (
            <Stack spacing={2} marginTop={2}>
                {batches.map((batch, i) => (
                  <BatchCard
                    key={batch.id}
                    data={batch}
                    selected={i === selectedBatch}
                    select={() => setSelectedBatch(i)}
                  />
                ))}
            </Stack>) : (
              <Typography sx={{ textAlign: "center", py: 5 }}>
                {"No batches found"}
              </Typography>
            )}
          </>
        )}
      </CardContent>
      <CardActions sx={{ justifyContent:"center", gap: 2 }} disableSpacing>
        <Tooltip
          title={"Number of students: " + (data.studentCount || 0)}
          arrow
        >
          <Chip
            sx={{ borderRadius: 1 }}
            icon={<GroupsRoundedIcon />}
            label={data.studentCount || 0}
          />
        </Tooltip>
        <Tooltip
          title={"Number of topics: " + (data.topicCount || 0)}
          arrow
        >
          <Chip
            sx={{ borderRadius: 1 }}
            icon={<TocRoundedIcon />}
            label={data.topicCount || 0}
          />
        </Tooltip>
        {showBatches ? (
          ""
        ) : (
          <Link style={{ width: "100%" }} to={`/academic/courses/${data.id}`}>
            <Button variant="contained" fullWidth>
              View Course
            </Button>
          </Link>
        )}
      </CardActions>

      <Menu anchorEl={menu} open={Boolean(menu)} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            edit()
            closeMenu()
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            deleteCourse()
            closeMenu()
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </Card>
  )
}

const BatchCard = ({ data, selected, select }) => {
  const [menu, setMenu] = useState(null)
  const openMenu = (event) => setMenu(event.currentTarget)
  const closeMenu = () => setMenu(null)

  const [classSchedule, setClassSchedule] = useState(false)
  const openClassSchedule = () => setClassSchedule(true)
  const closeClassSchedule = () => setClassSchedule(false)

  return (
    <Stack
      onClick={select}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        backgroundColor: selected
          ? "#acadf7"
          : "rgba(0, 0, 0, 0.06)",
        borderRadius: 2,
        py: 1,
        px: 2,
        cursor: "pointer",
      }}
    >
      <Typography>{data.name}</Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        <GroupsRoundedIcon />
        <span>{data.studentCount || 0}</span>
        <IconButton onClick={openMenu}>
          <MoreVertIcon />
        </IconButton>
      </Stack>
      <Menu anchorEl={menu} open={Boolean(menu)} onClose={closeMenu}>
        <MenuItem onClick={closeMenu}>Edit</MenuItem>
        <MenuItem onClick={closeMenu}>Delete</MenuItem>
        <MenuItem onClick={openClassSchedule}>Add Class Schedule</MenuItem>
      </Menu>
      <AddClassSchedule
        isOpen={classSchedule}
        close={closeClassSchedule}
        batchId={data.id}
        batchName={data.name}
      />
    </Stack>
  )
}
